module.exports = __webpack_public_path__ + "img/707.de5714ce.png";